import { render, staticRenderFns } from "./IpoInformationRow.vue?vue&type=template&id=ed74849a"
import script from "./IpoInformationRow.vue?vue&type=script&lang=js"
export * from "./IpoInformationRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports